import { Box, Input, Typography } from "@mui/joy";
import { useEffect, useState, useRef } from "react";
import { debounce } from "lodash";
import { Palette } from "lucide-react";

interface IColorSelection {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}
export function ColorSelection(props: IColorSelection) {
    const { value, onChange, loading } = { ...props };
    // Initialize state from prop value if available
    const [colorValue, setColorValue] = useState<string>(value || "");

    // Debounce the onChange callback to avoid excessive API calls
    const debouncedOnChange = useRef(
        debounce((newValue: string) => {
            onChange(newValue);
        }, 500) // 500ms delay
    ).current;

    const handleUpdate = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (loading) return;
        const newValue = event.target.value;
        // Update local state immediately for responsive UI
        setColorValue(newValue);
        // Debounce the API call
        debouncedOnChange(newValue);
    };

    useEffect(() => {
        // Handle null, undefined, and empty string - all should display as empty
        setColorValue(value || "");
    }, [value]);

    // Cleanup debounce on unmount
    useEffect(() => {
        return () => {
            debouncedOnChange.cancel();
        };
    }, [debouncedOnChange]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Roof color
            </Typography>
            <Input
                placeholder="Enter color and manufacturer (e.g., Charcoal Black, GAF)"
                value={colorValue}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Palette size={16} />}
                sx={{ width: "100%" }}
            />
        </Box>
    );
}
